import React from 'react';
import PanelHelpBadge from '../PanelHelpBadge';

const DATE_OPTIONS = [
  { value: 'today', label: 'Bugün' },
  { value: 'short', label: 'Son 7 Gün' },
  { value: 'default', label: 'Son 30 Gün' },
  { value: 'long', label: 'Son 90 Gün' }
];

const SURFACE_OPTIONS = [
  { value: '', label: 'Tüm Yüzeyler' },
  { value: 'mobile', label: 'Mobil' },
  { value: 'desktop', label: 'Masaüstü' }
];

const CONTEXT_OPTIONS = [
  { value: '', label: 'Tüm Bağlamlar' },
  { value: 'kitchen', label: 'Mutfak' },
  { value: 'shopping', label: 'Alışveriş' },
  { value: 'recommendation', label: 'Öneri' }
];

export default function DashboardTopBar({
  filters,
  onFilterChange,
  canExport,
  onExport,
  refreshedAtLabel
}) {
  return (
    <section className="min-h-16 rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-[#101922]">
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <h2 className="text-lg font-black text-slate-900 dark:text-white">Kontrol Merkezi</h2>
            <PanelHelpBadge
              title="Kontrol Merkezi"
              description="Bu alan ilk bakışta karar vermeyi hızlandırır ve detaylara tek noktadan inmeni sağlar."
              interpretation="Önce özet kartlara bak, sonra gerekirse Detaya git ile drawer aç."
              metricExample="Önce riskte olan kartı açmak, aksiyon hızını artırır."
            />
          </div>
          <p className="text-xs text-slate-500 dark:text-slate-400">Son güncelleme: {refreshedAtLabel || '-'}</p>
        </div>

        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
          <select
            value={filters.window}
            onChange={(e) => onFilterChange('window', e.target.value)}
            className="h-10 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-white"
          >
            {DATE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>

          <select
            value={filters.surface}
            onChange={(e) => onFilterChange('surface', e.target.value)}
            className="h-10 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-white"
          >
            {SURFACE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>

          <select
            value={filters.context}
            onChange={(e) => onFilterChange('context', e.target.value)}
            className="h-10 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-white"
          >
            {CONTEXT_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>

          <button
            type="button"
            onClick={onExport}
            disabled={!canExport}
            className={`h-10 rounded-lg px-4 py-2 text-sm font-bold transition-colors ${canExport
              ? 'bg-primary text-white hover:brightness-110'
              : 'cursor-not-allowed bg-slate-200 text-slate-500 dark:bg-slate-800 dark:text-slate-400'
            }`}
          >
            Dışa Aktar
          </button>
        </div>
      </div>
    </section>
  );
}
